import { Label } from 'reactstrap';
import Select from 'react-select';
import { useSelector, useDispatch } from 'react-redux';
import { setField } from 'Features/Learning/BankQuestions/addQuestionSlice';

const CategorySelectForm = () => {
  const dispatch = useDispatch();
  const data = useSelector(state => state.addQuestion)
  const dataOptions = [
    { value: 'multiple_choice', label: 'Pilihan Ganda' },
    { value: 'fill_in_the_blanks', label: 'Isian Singkat' },
    { value: 'sentence_arrangement', label: 'Susunan Kalimat' },
  ];

  const parentTitle = data.type ? dataOptions.find(item => item.value === data.type)?.label : null;

  const handleSelectChange = (selectedOption) => {
    if (selectedOption !== null) {
      dispatch(setField({ field: 'type', value: selectedOption.value }));
    } else {
      dispatch(setField({ field: 'type', value: '' }));
    }
  };
  return (
    <div className="mb-3">
      <Label className="col-form-label" style={{ fontWeight: 'bold' }}>{'Tipe Soal'}:</Label>
      <Select
        className="basic-single"
        classNamePrefix="select"
        placeholder="Pilihlah tipe soal..."
        isClearable
        isSearchable
        name="color"
        options={dataOptions}
        onChange={handleSelectChange}
        getOptionLabel={(option) => option.label}
        getOptionValue={(option) => option.value}
        value={{ value: data.type, label: parentTitle }}
        isDisabled={data.isUpdate}
      />
    </div>
  );
};
export default CategorySelectForm;